export enum LocalesEnum {
    en_GB = 'en_GB',
    de_CH = 'de_CH',
    es_ES = 'es_ES',
    fi_FI = 'fi_FI',
    fr_FR = 'fr_FR',
    it_IT = 'it_IT',
    nb_NO = 'nb_NO',
    nl_NL = 'nl_NL',
    pl_PL = 'pl_PL',
    ru_RU = 'ru_RU',
    sv_SE = 'sv_SE',
    tr_TR = 'tr_TR',
    fr_CH = 'fr_CH',
    en_US = 'en_US',
    fr_CA = 'fr_CA',
    es_MX = 'es_MX',
    zh_CN = 'zh_CN',
    zh_HK = 'zh_HK',
    zh_TW = 'zh_TW',
    pt_BR = 'pt_BR',
    hu_HU = 'hu_HU',
    sl_SI = 'sl_SI',
    sk_SK = 'sk_SK',
    sr_RS = 'sr_RS',
    sr_BA = 'sr_BA',
    mk_MK = 'mk_MK',
    hr_HR = 'hr_HR',
    bg_BG = 'bg_BG',
    cs_CZ = 'cs_CZ',
    da_DK = 'da_DK',
    et_EE = 'et_EE',
    el_GR = 'el_GR',
    he_IL = 'he_IL',
    lv_LV = 'lv_LV',
    lt_LT = 'lt_LT',
    ro_RO = 'ro_RO',
    fa_IR = 'fa_IR',
}
